import PubSub from "underpub-js";

var HeroBasicAlternate = function(options) {

	this.options = {
		$el: false,
		baseClass: 'MOL-HeroBasicAlternate',
	};

	$.extend(true, this.options, options);

};

HeroBasicAlternate.prototype.init = function() {

	var self = this;

};

export default HeroBasicAlternate;
